(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/jupiter.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/jupiter.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const rowBreakpoint = 1400;
class Jupiter {
  constructor(_ref) {
    let {
      data,
      jupiterOptions,
      onSuccess,
      onError
    } = _ref;
    if (this.isOwnRows(data) && this.isLargeSystem(data)) data = this.splitLargeSystem(data);
    this.options = _objectSpread({
      method: 'POST',
      path: this.getPath(data),
      data: this.isMultiWager(data) ? {
        wagers: data
      } : data
    }, jupiterOptions);
    this.onSuccess = onSuccess;
    this.onError = onError;
  }
  call() {
    if (this.options.data.wagers && this.options.data.wagers.length > 10) {
      this.chunkPayment();
    } else {
      svs.core.jupiter.call(this.options, (response, textStatus, xhr) => {
        svs.components.account_balance.get(true);
        this.onSuccess && this.onSuccess({
          response,
          textStatus,
          xhr
        });
      }, (xhr, textStatus, errorThrown) => {
        this.onError && this.onError(xhr, textStatus, errorThrown);
      });
    }
  }

  chunkPayment() {
    const half = Math.ceil(this.options.data.wagers.length / 2);
    const firstHalf = this.options.data.wagers.splice(0, half);
    const secondHalf = this.options.data.wagers.splice(-half);
    this.options.data.wagers = firstHalf;
    const optionsCopy = _objectSpread(_objectSpread({}, this.options), {}, {
      data: {
        wagers: secondHalf
      }
    });
    svs.core.jupiter.call(optionsCopy, () => {
      this.call();
    }, (xhr, textStatus, errorThrown) => {
      this.onError && this.onError(xhr, textStatus, errorThrown);
    });
  }
  getPath(data) {
    return this.isMultiWager(data) ? '/wager/9/multiwagers' : '/wager/9/wagers';
  }
  isMultiWager(data) {
    return Array.isArray(data);
  }
  isOwnRows(data) {
    if (this.isMultiWager(data)) data = data[0];
    return Boolean(data.bets && data.bets[0].erNumberBoardData);
  }

  isLargeSystem(data) {
    if (!this.isOwnRows(data)) return false;
    if (this.isMultiWager(data)) data = data[0];
    const rows = data.bets[0].erNumberBoardData.boards;
    return rows && rows.length > rowBreakpoint;
  }

  splitLargeSystem(data) {
    const wagerArray = [];
    if (!this.isMultiWager(data)) data = [data];
    data.forEach(wager => wager.bets.forEach(bet => {
      const boards = bet.erNumberBoardData.boards;
      const pricePerRow = parseInt(bet.betAmountSalesGroup1, 10) / boards.length;
      const hasLotto2 = Boolean(parseInt(bet.betAmountSalesGroup2, 10));
      let i = 0;
      while (boards.length) {
        const tmpBoards = boards.splice(0, rowBreakpoint);
        const totalPrice = pricePerRow * tmpBoards.length;
        wagerArray.push({
          sequenceNum: i,
          bagType: 0,
          bets: [_objectSpread(_objectSpread({}, bet), {}, {
            betAmountSalesGroup1: "".concat(totalPrice, ",00"),
            betAmountSalesGroup2: hasLotto2 ? "".concat(totalPrice, ",00") : '0,00',
            erNumberBoardData: {
              boards: tmpBoards
            },
            betProperties: ['EGNARADER'],
            egnaRaderParticipation: hasLotto2 ? 'L1L2' : 'L1'
          })]
        });
        i++;
      }
    }));
    return wagerArray;
  }
}
svs.tur.payment.api.jupiter.Jupiter = Jupiter;

 })(window);